import { render } from "./CaregiverForm.vue?vue&type=template&id=dc40cd1c&ts=true"
import script from "./CaregiverForm.vue?vue&type=script&lang=ts"
export * from "./CaregiverForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Caregivers/CaregiverForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc40cd1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc40cd1c', __exports__)) {
    api.reload('dc40cd1c', __exports__)
  }
  
  module.hot.accept("./CaregiverForm.vue?vue&type=template&id=dc40cd1c&ts=true", () => {
    api.rerender('dc40cd1c', render)
  })

}


export default __exports__